"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    centered: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: '300px',
        maxHeight: '510px',
        padding: theme.spacing(3)
    },
    bonusDetails: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: theme.spacing(2)
    },
    titleText: {
        paddingBottom: theme.spacing()
    },
    newChanceText: {
        textAlign: 'center',
        paddingBottom: theme.spacing(1)
    },
    bonusEntry: {
        fontWeight: 'bold',
        paddingBottom: theme.spacing(1)
    },
    newPointsSection: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('xs')]: {
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4)
        }
    },
    button: {
        paddingTop: theme.spacing() + 2,
        paddingBottom: theme.spacing() + 2,
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6),
        borderRadius: '10px'
    },
    winningNumberText: {
        textAlign: 'center',
        fontSize: '15px',
        [theme.breakpoints.down('md')]: {
            fontSize: '12px'
        },
        paddingBottom: theme.spacing(1)
    },
    EarnedMsg: {
        textAlign: 'center',
        fontSize: '15px',
        [theme.breakpoints.down('md')]: {
            fontSize: '12px'
        }
    },
    gameImageStyle: {
        width: '54%',
        height: '5%',
        [theme.breakpoints.down('md')]: {
            width: '45%',
            height: '100%'
        }
    }
});
exports.default = styles;
//# sourceMappingURL=SuperBonusModalStyles.js.map